import config from '../../../config/config.js';//api配置
import axios from 'axios';//http库
import {Toast} from "vant";
import store from '../store/';//vuex文件
import common from '../tool.js';//一些公共方法
//import {MessageBox} from 'element-ui';//引入一个消息弹窗
import {getCookie, removeCookie} from './cookie.js';//用来对token的取、写、删；
import {serverException} from './serverException.js';//请求异常的结果处理
import { auth } from "./auth.js";
import * as s from "../tool";
let java = config.api;
var sn

axios.defaults.withCredentials = true;//解决sessionId不一致问题

// 创建axios实例
const service = axios.create({
    baseURL: '', // api的base_url
    timeout: 60000 * 2 // 请求超时时间 时间为1分钟
});
service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // 请求头添加token
    // console.log(s.setAuthKey())

    config.headers[s.setAuthKey()] = localStorage.getItem("token");
    config.headers['openid'] = localStorage.getItem("openid");
    if(s && typeof s.sn === "function") {
        sn = s.sn();
        for(let key in sn) {
            config.headers[key] = sn[key];
        }
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(response => {
    // 对响应数据做点什么
    return response;
}, error => {
    if (error && error.response.status != 404) {
        serverException(error.response);
    }
    return Promise.reject(error);
});
let CancelToken = service.CancelToken = axios.CancelToken;//这个，还没发现有什么大用

export const $http = {
    //作为方法，时刻调用
    token: x => x = localStorage.getItem("token"),
    cancel: null,
    //Java的请求方法
    request(path, req) {
        const that = this;
        req.loginId = localStorage.getItem("loginId");
        if (req == null || req == undefined) req = {};
        let flag = '?';
        if (path.indexOf("?") != -1) {
            flag = '&';
        }
        if(path.indexOf('codeCheckInfo') > -1){
            java = "https://lb-system-2025.lbreeb.com/afzj"
            // java = "http://192.168.0.110:8081/afzj"
        }
        const ax = service({
            method: 'post',
            url: `${java}${path}`,//java + path + '?token='+this.token, ${flag}token=${this.token()}
            data: req,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem("token"),
                'token': localStorage.getItem("token"),
            },
            cancelToken: new CancelToken(function executor(c) {
                //这个executor 函数接受一个cancel function作为参数
                that.cancel = c;
            })
        });
        ax.do = fn => {
            this.callback(ax, fn);
        };
        return ax
    },
    // get 请求
    get(path, req) {
        const that = this;
        if (req == null || req == undefined) req = {};
        let url = this.joint(path, req);
        const ax = service({
            method: "get",
            url: url, //java + path + '?token='+this.token,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
                "authorization": localStorage.getItem("token"),
                "token": localStorage.getItem("token"),
            },
            cancelToken: new CancelToken(function executor(c) {
                //这个executor 函数接受一个cancel function作为参数
                that.cancel = c;
            }),
        });
        ax.do = (fn) => {
         this.callback(ax, fn);
        };
        return ax;
    },
    //给java用的回调处理
    callback(ax, fn) {
        ax.then(response => {
            const data = response.data;
            console.log("BEN:" + data.code);
            if(data.code == 403) {
                localStorage.removeItem("code");
                // auth();
                return;
            }
            // if(data.code !== 100){
            //     Toast({
            //         type:"fail",
            //         icon:"none",
            //         message:"服务异常"
            //     })
            // }
            fn(data);
        }).catch(err => {
            console.log(err)
            fn(null,err)
            Toast({
                type:"fail",
                icon:"none",
                message:"服务异常"
            })
            // if (err.response.status && err.response.status == 404) {
            //   router.push('/admin/404');
            // }
        })
    },

    //下载导出方法
    download(path, param) {
        window.open(this.joint(path, param));
    },
    //java的接口地址拼接
    joint(path, param) {
        if (param == null || param == undefined) param = {};
        let flag = '?';
        if (path.indexOf("?") != -1) {
            flag = '&';
        }
        let p = `${java}${path}`; // ${flag}token=${this.token()}
        for (const i in param) {
            p += `${flag}${i}=${param[i]}`;
            flag = '&';
        }
        return p;
    },

}



// WEBPACK FOOTER //
// ./src/other/utils/fetch.js